import { loadSiteConfigList as apiLoadSiteConfigList, SitesLoadData } from '../../../rest-api/SiteConfig-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

export const LoadSiteConfigList = actionCreator.async<string, SitesLoadData, string>(
  'LoadSiteConfigList'
)
export const SiteQueryChanged = actionCreator<string>('SiteQueryChanged')

const loadSiteConfigListWorker = wrapAsyncWorker(LoadSiteConfigList, apiLoadSiteConfigList)

// thunk action creator
export const loadSiteConfigList = (market: string) => {
  return (dispatch: Dispatch<AnyAction>) => loadSiteConfigListWorker(dispatch, market)
}
